import React from "react";

import HeaderTableAttributes from "./HeaderTableAttributes";
import RowsAttributes from "./RowsAttributes";
import "./styles.css";

const AttributesTable = ({
  rows,
  attributesPicked,
  handlePickedAttribute,
  handlePickedAllAttributes,
  selectedAll,
  handleSortChange,
  sort,
}) => {
  return (
    <div className="attributes-table">
      <HeaderTableAttributes
        handlePickedAllAttributes={handlePickedAllAttributes}
        selectedAll={selectedAll}
        handleSortChange={handleSortChange}
        sort={sort}
      />

      <RowsAttributes rows={rows} attributesPicked={attributesPicked} handlePickedAttribute={handlePickedAttribute} />
    </div>
  );
};

export default AttributesTable;
